import { Link, NavLink } from "react-router-dom";
import { Menu, X, Ribbon } from "lucide-react";
import { useState } from "react";
import { Button } from "./ui/button";

const links = [
  { to: "/", label: "Home" },
  { to: "/#note", label: "About" },
  { to: "/resources", label: "Resources" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-200" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-home-link">
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-teal-700 text-white">
            <Ribbon className="w-4 h-4" />
          </span>
          <div className="leading-tight">
            <div className="font-serif text-lg text-slate-900">Dr. Jasmine Porwal</div>
            <div className="text-[11px] uppercase tracking-wider text-teal-700 font-medium">Medical Oncology</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-7">
          {links.map(l => (
            <a key={l.to} href={l.to} className="text-sm text-slate-700 hover:text-teal-700 transition-colors" data-testid={`nav-link-${l.label.toLowerCase()}`}>
              {l.label}
            </a>
          ))}
          <Link to="/book">
            <Button className="bg-teal-700 hover:bg-teal-800 text-white rounded-full px-5" data-testid="nav-book-btn">Book Consultation</Button>
          </Link>
        </nav>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-3">
          {links.map(l => (
            <a key={l.to} href={l.to} className="block text-slate-700" onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.label.toLowerCase()}`}>{l.label}</a>
          ))}
          <Link to="/book" onClick={() => setOpen(false)}>
            <Button className="w-full bg-teal-700 hover:bg-teal-800 text-white rounded-full" data-testid="mobile-book-btn">Book Consultation</Button>
          </Link>
        </div>
      )}
    </header>
  );
}
